<template lang='pug'>
.d-flex.justify-center.pb-16
  v-btn(
    :disabled='disabled'
    :loading='loading'
    @click='$emit("click")'
    color='primary'
    elevation='24'
    rounded
    x-large
  )
    slot #[v-icon(left) mdi-check] Okay
</template>

<script>
const disabled =
{
  required: true
};

const loading =
{
  default: false,
  required: false,
};

export default
{
  props:
  {
    disabled,
    loading,
  }
};
</script>